import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import Menu from "./components/Menu/Menu";
import Header from "./components/Header/Header";
import HeaderBO from "./components/Header/HeaderBO";
import Body from "./components/Body/Body";
import AppMem from "./common/AppMem";
import { connect } from "react-redux";
import { actionChangeAppProps, actionFirstTime } from "./actions/AppAction";
import { actionLogOut, confirmEmail } from "./actions/AuthActions";
import {
	LOGIN,
	INDEX,
	CONFIRMPASSWORD,
	CONFIRMEMAIL
} from "./config/RoutesConstants";
import ConfirmDialog from "./components/ConfirmDialog/ConfirmDialog";
import "./App.css";
import { Settings } from "./provider/base";

//local - dev - st - prod
Settings.env = "prod";

const muiTheme = getMuiTheme({
	palette: {
		textColor: "#000000",
		primary1Color: "#2d5986",
		secondaryTextColor: "#6d6d6d",
		alternateTextColor: "#ffffff",
		disabledColor: "#70787D"
	},
	appBar: {
		height: 30,
		textColor: "#FFFFFF",
		padding: 5
	},
	badge: {
		secondaryColor: "#3B3C3C"
	},
	button: {
		height: 30,
		minWidth: 40
	},
	checkbox: {
		boxColor: "#70787d",
		labelColor: "#70787d",
		fontSize: 12
	},
	card: {
		titleColor: "#424242"
	},
	datePicker: {
		selectColor: "#3B3C3C",
		headerColor: "#006080"
	},
	dialog: {
		titleFontSize: 18,
		bodyFontSize: 13
	},
	flatButton: {
		fontSize: 12
	},
	floatingActionButton: {
		buttonSize: 35,
		miniSize: 25,
		color: "#006080"
	},
	menuItem: {
		dataHeight: 5,
		height: 30,
		padding: 0,
		fontSize: 10,
		selectedTextColor: "#006080",
		rightIconDesktopFill: "#ff0000",
		spacing: 5
	},
	raisedButton: {
		fontSize: 12,
		height: 20,
		primaryColor: "#006080",
		secondaryColor: "#6d6d6d"
	},
	tableHeader: {
		whiteSpace: "normal",
		//height: 10,
		borderSize: 2
	},
	tableHeaderColumn: {
		height: 10,
		spacing: 10,
		//textColor: "#FFFFFF",
		whiteSpace: "normal",
		fontSize: 10
	},
	tableRow: {
		stripeColor: "#F0F0F0",
		border: "1px solid #ccc",
		height: 40
	},
	tableRowColumn: {
		height: 25,
		spacing: 10
	},
	tableFooter: {
		borderColor: "#EB825D"
	},
	textField: {
		hintColor: "rgba(0, 0, 0, 0.3)",
		focusColor: "#424242"
	},
	timePicker: {
		headerColor: "#F88100"
	}
});

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openLeftDrawer: this.props.pathname === INDEX ? false : true,
			token: this.props.token,
			firebaseToken: this.props.firebaseToken,
			emailConfirm: this.props.emailConfirm
		};
		this.Logout = this.Logout.bind(this);
		this.LogoutSuccess = this.LogoutSuccess.bind(this);
		this.confirmEmailSuccess = this.confirmEmailSuccess.bind(this);
	}

	componentWillMount() {
		if (
			this.props.location.pathname !== CONFIRMPASSWORD &&
			this.props.location.pathname !== CONFIRMEMAIL
		) {
			if (this.state.token === "no logged") {
				this.props.history.push(LOGIN);
			} else {
				if (!this.props.firstTimeFlag)
					this.props.actionFirstTime(
						this.state.token,
						this.state.firebaseToken,
						this.Logout
					);
			}
		} else {
			if (this.props.location.pathname === CONFIRMEMAIL) {
				let tokenEmail = /token=([^&]+)/.exec(this.props.location.search)[1];

				this.props.confirmEmail(tokenEmail, this.confirmEmailSuccess);
			}
		}
	}

	confirmEmailSuccess() {
		this.setState({ emailConfirm: true });
	}

	toggleLeftDrawer = () =>
		this.setState({ openLeftDrawer: !this.state.openLeftDrawer });

	Logout() {
		this.props.actionLogOut(this.LogoutSuccess);
	}
	LogoutSuccess() {
		this.props.history.replace(LOGIN);
	}
	componentDidMount() {
		AppMem.confirmDialog = this.refs["globalConfirmDialog"];
		AppMem.infoDialog = this.refs["globalInfoDialog"];
	}
	componentDidUpdate() {
		AppMem.confirmDialog = this.refs["globalConfirmDialog"];
		AppMem.infoDialog = this.refs["globalInfoDialog"];
	}
	renderHeader(loggedIn) {
		if (!loggedIn) {
			return (
				<Header
					leftIconClick={this.toggleLeftDrawer}
					hideDrawer={this.state.openLeftDrawer}
				/>
			);
		}
		const openCloseMenu = openLeftDrawer => this.setState({ openLeftDrawer });
		return (
			<div>
				<HeaderBO
					leftIconClick={this.toggleLeftDrawer}
					hideDrawer={this.state.openLeftDrawer}
					login={this.props.login}
				/>
				<Menu
					email={this.props.email}
					rol={this.props.rol}
					onTouchTapItems={this.toggleLeftDrawer}
					userDrawer={"Bienvenido"}
					navDrawerOpen={this.state.openLeftDrawer}
					logout={this.Logout}
					onRequestChangeDrawer={openCloseMenu}
				/>
			</div>
		);
	}

	render() {
		const loggedIn = this.props.login;
		const htmlHeader = this.renderHeader(loggedIn);
		return (
			<div style={loggedIn ? { height: "100%" } : { height: "auto" }}>
				<MuiThemeProvider muiTheme={muiTheme}>
					<div style={{ paddingBottom: "50px" }}>
						{htmlHeader}
						<Body confirmEmail={this.props.emailConfirm} />
						<ConfirmDialog ref="globalConfirmDialog" />
						<ConfirmDialog info={true} ref="globalInfoDialog" />
					</div>
				</MuiThemeProvider>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		login: store.session.authenticated,
		username: store.app.username,
		email: store.app.username,
		rol: store.app.rol,
		firstTimeFlag: store.app.firstTimeFlag,
		emailConfirm: store.app.confirmEmail
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionChangeAppProps,
			actionLogOut,
			actionFirstTime,
			confirmEmail
		},
		dispatch
	);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js